import { observable, computed, action, makeObservable } from 'mobx'

class RangeFilter {
  @observable value
  @observable disabled = false
  _defaultValue

  constructor (defaultValue = [0, 100], disabled = false) {
    makeObservable(this)
    this._defaultValue = defaultValue.slice()
    this.value = defaultValue.slice()
    this.disabled = disabled
  }

  @computed get min () {
    return this.value[0]
  }

  @computed get max () {
    return this.value[1]
  }

  @computed get defaultMin () {
    return this._defaultValue[0]
  }

  @computed get defaultMax () {
    return this._defaultValue[1]
  }

  @computed get isAtDefault () {
    return this.value[0] === this._defaultValue[0] &&
           this.value[1] === this._defaultValue[1]
  }

  @action reset () {
    this.value = [...this._defaultValue]
  }

  @action setValue (newValue) {
    this.value = newValue.slice()
  }

  @action setDisabled (disabled) {
    this.disabled = !!disabled
  }
}

export default RangeFilter
